import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { loginWithMockService } from "../services/mockAuthService";

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const nextPath = location.state?.from?.pathname || "/dashboard";

  if (isAuthenticated) {
    return <Navigate to={nextPath} replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const session = await loginWithMockService(username.trim(), password);
      login(session);
      navigate(nextPath, { replace: true });
    } catch (submitError) {
      setError(submitError.message || "Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-panel">
        <div className="login-brand-stack" aria-label="WOW-Sign brand">
          <img className="login-brand-logo" src="/main-logo.svg" alt="WOW-Sign" />
        </div>

        <h1 className="login-heading">Login to your account.</h1>
        <p className="login-subheading">Access the WOW-Sign admin workspace.</p>

        <form className="login-form" onSubmit={handleSubmit}>
          {error && <div className="error-banner login-error">{error}</div>}

          <div className="form-grid login-fields">
            <input
              id="username"
              className="input login-input"
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="User Name"
              autoComplete="username"
              required
            />

            <input
              id="password"
              className="input login-input"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Password"
              autoComplete="current-password"
              required
            />

            <button className="btn btn-primary login-submit" type="submit" disabled={submitting}>
              {submitting ? "LOGGING IN" : "LOGIN"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
